








































































import Vue from "vue";
import { mapGetters } from "vuex";

// Components
import MachinePropsList from "@/components/PropsLists/MachinePropsList.vue";

// Model
import { Machine } from "@/model/data/Machine";
import { getImageFromModel_200 } from "@/utility/Constants";
import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { SendMachineResetCommand, SendMachineResetReqData } from "@/model/communication/device/SendMachineResetCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    components: {
        MachinePropsList,
    },
    props: {
        machine: { type: Object as () => Machine, required: true },
        showResetButton: { type: Boolean, default: true },
        hasAgent: Boolean,
    },
    data() {
        return {
            ClientPrivileges,
            resetLoading: false,
            resetIcon: "fas fa-wrench",
            showResetDialog: false,
            resetError: false,
            resetErrorMessage: "",
            alertType: "",
        };
    },
    computed: { ...mapGetters(["authUserHasPrivilege"]) },
    methods: {
        getImageFromModel_200,
        async sendReset() {
            try {
                this.resetLoading = true;
                this.resetIcon = "fa-solid fa-circle-notch fa-spin";
                let reqData = new SendMachineResetReqData(this.machine.installationName, this.machine.serialNumber);
                let response: ApiGenericResponse = await new SendMachineResetCommand(reqData).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString.toLowerCase() == "success") {
                    this.resetIcon = "fas fa-check";
                } else {
                    throw response.message;
                }
            } catch (error) {
                switch (error) {
                    case CReqExecutionResultEnum.AgentOffline:
                        this.resetErrorMessage = this.$t("device_status.agentOfflineForInstallation", { task: "reset" });
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.AgentNotInstalled:
                        this.resetErrorMessage = this.$t("device_status.agentNotInstalled", { task: "reset" });
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.DeviceLocked:
                        this.resetErrorMessage = this.$t("device_status.agentLocked", { task: "reset" });
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.OperationNotAvailable:
                        this.resetErrorMessage = this.$t("device_status.operationNotAvailable", { task: "reset" });
                        this.alertType = "info";
                        break;
                    case CReqExecutionResultEnum.ServerError:
                        this.resetErrorMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.InvalidRequest:
                        this.resetErrorMessage = this.$t("device_status.invalidVersion", { task: "reset" });
                        this.alertType = "error";
                        break;
                    default:
                        console.error("Something went wrong sending MachineReset request ", error);
                        this.resetErrorMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        break;
                }
                this.resetIcon = "fas fa-wrench";
                this.resetError = true;
            }
            this.resetLoading = false;
        },
    },
});
